import React from "react";

import { Row, Col  , Input ,Pagination } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Laws/Laws.css";

const continueStyle ={
    fontFamily:"IranSansUltraLight" , 
    fontSize:".9em" , 
    color:"#ed1c24",
    opacity:"90%"
}
const continueStyleTablet = {
    fontFamily: "IranSansUltraLight",
    fontSize: ".85em",
    color: "#ed1c24",
    opacity: "90%"
}
const continueStyleMobile = {
    fontFamily: "IranSansUltraLight",
    fontSize: ".8em",
    color: "#ed1c24",
    opacity: "90%"
}
const titleStyle ={
    fontFamily:"IranSans" , 
    fontSize:".8em" , 
    direction:"rtl" , 
    textAlign:"right" , 
    color:"#186491"
}
const titleStyleTablet = {
    fontFamily: "IranSans",
    fontSize: ".8em",
    direction: "rtl",
    textAlign: "right",
    color: "#186491"
}
const titleStyleMobile = {
    fontFamily: "IranSans",
    fontSize: ".75em",
    direction: "rtl",
    textAlign: "right",
    color: "#186491"
}
const numberStyle ={
    fontFamily:"IranSans",
    color:"#6e6e6e"
}
const numberStyleTablet = {
    fontFamily: "IranSans",
    color: "#6e6e6e",
    fontSize:".85px"
}
const numberStyleMobile = {
    fontFamily: "IranSans",
    color: "#6e6e6e",
    fontSize:".8em"
}

const LawsList =(props) =>{
     return props.size === "laptopdesktop" ? (
        <div>
            <Row>
                <Col span={22}>
                    <div style={{borderRadius:"10px" ,backgroundColor:props.color , padding:"5px"}}>
                        <Row>
                            <Col span={4}>
                                <Center>
                                    <div>
                                        <a href={props.link} style={continueStyle}>
                                            ادامه
                                        </a>
                                    </div>
                                </Center>
                            </Col>
                            <Col span={19} style={{direction:"rtl" , textAlign:"right"}}>
                                <strong style={titleStyle}>
                                    {props.title}
                                </strong>
                            </Col>
                            <Col span={1}></Col>
                        </Row>
                    </div>
                    <Margin top={2}></Margin>
                    
                </Col>
                <Col span={2}>
                    <Center>
                        <div style={{marginTop:"5px"}}>
                            <p style={numberStyle}>
                            <strong>
                                {props.number}
                            </strong>
                            </p>
                        </div>
                    </Center>
                </Col>
            </Row>
        </div>
     ) : props.size === "tablet" ? (
            <div>
                 <Row>
                     <Col span={22}>
                         <div style={{ borderRadius: "10px", backgroundColor: props.color, padding: "5px" }}>
                             <Row>
                                 <Col span={4}>
                                     <Center>
                                         <div>
                                            <a href={props.link} style={continueStyleTablet}>
                                                 ادامه
                                            </a>
                                         </div>
                                     </Center>
                                 </Col>
                                 <Col span={19} style={{ direction: "rtl", textAlign: "right" }}>
                                     <strong style={titleStyleTablet}>
                                         {props.title}
                                     </strong>
                                 </Col>
                                 <Col span={1}></Col>
                             </Row>
                         </div>
                         <Margin top={2}></Margin>

                     </Col>
                     <Col span={2}>
                         <Center>
                             <div style={{ marginTop: "5px" }}>
                                 <p style={numberStyleTablet}>
                                     <strong>
                                         {props.number}
                                     </strong>
                                 </p>
                             </div>
                         </Center>
                     </Col>
                 </Row>
            </div>

     ) : (
            <div>
                <Row>
                    <Col span={22}>
                        <div style={{ borderRadius: "10px", backgroundColor: props.color, padding: "5px" }}>
                            <Row>
                                <Col span={4}>
                                    <Center>
                                        <div>
                                            <a href={props.link} style={continueStyleMobile}>
                                                ادامه
                                            </a>
                                        </div>
                                    </Center>
                                </Col>
                                <Col span={19} style={{ direction: "rtl", textAlign: "right" }}>
                                    <strong style={titleStyleMobile}>
                                        {props.title}
                                    </strong>
                                </Col>
                                <Col span={1}></Col>
                            </Row>
                        </div>
                        <Margin top={2}></Margin>
                    </Col>
                    <Col span={2}>
                        <Center>
                            <div style={{ marginTop: "5px" }}>
                                <p style={numberStyleMobile}>
                                    <strong>
                                        {props.number}
                                    </strong>
                                </p>
                            </div>
                        </Center>
                    </Col>
                </Row>
            </div>
          );
};

export default LawsList;
